/**
 * useCanManageRecordProcedures — czy user widzi Ustawienia → „Procedury SQL" → zakładka „Kartoteki"
 * (katalog procedur SQL kartotek: podpinanych do momentów control/saved/delete zapisu rekordu oraz
 * uruchamianych ręcznie z przycisku SQL na formularzu rekordu — zdarzenie button).
 *
 * Warunek: `isSuperUser` LUB permission `crm_core.record_procedures.manage`. BEZ sprawdzania
 * modułu — `crm_core` jest pakietem bazowym, zawsze aktywnym dla każdego tenanta (inaczej niż
 * `useCanManageProcessProcedures`, gdzie moduł `processes` jest opcjonalną subskrypcją).
 *
 * Backend gate (jedno uprawnienie na wszystko — podgląd/CRUD/test/restore):
 * `apps/api/app/api/settings/record-procedures/route.ts` (`canTenantWide(ctx,
 * 'crm_core.record_procedures.manage')`).
 */
import { type TenantMeResponse, useTenantAuth } from '@/contexts/TenantAuthContext';

/** Czysta wersja (bez kontekstu) — dla miejsc, które mają `me` z opcjonalnego kontekstu. */
export function canManageRecordProcedures(me: TenantMeResponse | null | undefined): boolean {
  const isSuperUser = me?.user.isSuperUser === true;
  const hasPermission = me?.permissions.includes('crm_core.record_procedures.manage') ?? false;
  return isSuperUser || hasPermission;
}

export function useCanManageRecordProcedures(): boolean {
  const { me } = useTenantAuth();
  return canManageRecordProcedures(me);
}
